import { React, useState, useEffect } from 'react';

function HowToDrawContent(props) {

  const [faker, setFaker] = useState(false);

  useEffect(() => {
    setFaker(props.player.faker);
  }, [props.player.faker]);

  if (faker) {
    return (
      <div>
        <p>Now, everyone must submit a vote for who they think the fake artist is.</p>
        <p>As the imposter artist, try to blend in and avoid suspicion. You must still vote, but your vote will not be counted.</p>
        <p>Select the player name on the left, then click the Vote button to submit your vote!</p>
      </div>
    );
  }
  else {
    return (
      <div>
        <p>Now, everyone must submit a vote for who they think the fake artist is.</p>
        <p>Select the player name on the left that you suspect is the fake artist, then click the Vote button to submit your vote!</p>
      </div>
    );
  }
}

export default HowToDrawContent;
